export default __webpack_public_path__ + "static/287-ecee44c05607154ba86540f328ee4d4b.gif";